const getInternalLinkUrl = (e) => {
  const link = e.target.closest("a");
  if (!link) return null;

  const href = link.getAttribute("href");
  if (!href) return null;
  if (link.target === "_blank") return null;
  if (href.startsWith("#")) return null;
  if (href.startsWith("mailto:") || href.startsWith("tel:")) return null;
  if (href.includes("/wp-admin")) return null;

  const url = new URL(href, window.location.href);
  if (url.origin !== window.location.origin) return null;

  return url;
};

const initPageTransitions = (type = "fade") => {
  const overlay = document.createElement("div");
  overlay.id = "gk-overlay";
  overlay.className = "gk-overlay";
  document.body.appendChild(overlay);

  if (type === "wipe-up" || type === "wipe-left") {
    document.body.style.opacity = "0";

    const axis = type === "wipe-up" ? "Y" : "X";
    const easing = "transform 0.5s cubic-bezier(.76, 0, .24, 1)";
    const FADE_DURATION_MS = 800;

    const fadeInBody = () => {
      document.body.style.transition = `opacity ${FADE_DURATION_MS}ms cubic-bezier(0.16, 1, 0.3, 1)`;
      document.body.style.opacity = "1";
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent("gk:content-visible"));
      }, FADE_DURATION_MS);
    };

    // Covering state on page load (no transition yet, prevents initial snap)
    overlay.style.background = "var(--gk-overlay-color)";
    overlay.style.transform = `translate${axis}(0)`;
    overlay.style.transition = "none";

    // Reveal: slide overlay DOWN/RIGHT off screen, then fade in body
    window.addEventListener("DOMContentLoaded", () => {
      overlay.style.transition = easing;

      requestAnimationFrame(() => {
        overlay.style.transform = `translate${axis}(100%)`;
        overlay.style.pointerEvents = "none";
        fadeInBody();
      });
    });

    // Entry on click: snap above/left instantly, then slide DOWN/RIGHT to cover
    document.addEventListener("click", (e) => {
      const url = getInternalLinkUrl(e);
      if (!url) return;

      e.preventDefault();

      overlay.style.transition = "none";
      overlay.style.transform = `translate${axis}(-100%)`;
      overlay.style.pointerEvents = "all";

      requestAnimationFrame(() => {
        overlay.style.transition = easing;

        requestAnimationFrame(() => {
          overlay.style.transform = `translate${axis}(0)`;

          overlay.addEventListener(
            "transitionend",
            () => {
              window.location.href = url.href;
            },
            { once: true },
          );
        });
      });
    });

    // Retour navigateur (bfcache) : la page est restaurée avec l'overlay encore
    // couvrant. pageshow.persisted ne déclenche PAS DOMContentLoaded → on remet
    // l'overlay hors écran et le body visible, sans transition.
    window.addEventListener("pageshow", (e) => {
      if (!e.persisted) return;
      overlay.style.transition = "none";
      overlay.style.transform = `translate${axis}(100%)`;
      overlay.style.pointerEvents = "none";
      document.body.style.transition = "none";
      document.body.style.opacity = "1";
    });

    return;
  }

  // fade: body masqué le temps que l'overlay soit peint (évite le FOUC)
  document.body.style.opacity = "0";

  const DURATION_IN = 600;
  const DURATION_OUT = 400;

  overlay.style.opacity = "1";
  overlay.style.transition = "none";

  window.addEventListener("DOMContentLoaded", () => {
    // body snap à 1 instantanément — l'overlay le couvre encore
    document.body.style.opacity = "1";
    document.body.style.transition = "none";

    requestAnimationFrame(() => {
      overlay.style.transition = `opacity ${DURATION_IN}ms cubic-bezier(0.16, 1, 0.3, 1)`;
      overlay.style.opacity = "0";
      overlay.style.pointerEvents = "none";
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent("gk:content-visible"));
      }, DURATION_IN);
    });
  });

  document.addEventListener("click", (e) => {
    const url = getInternalLinkUrl(e);
    if (!url) return;

    e.preventDefault();

    overlay.style.transition = "none";
    overlay.style.opacity = "0";
    overlay.style.pointerEvents = "all";

    requestAnimationFrame(() => {
      overlay.style.transition = `opacity ${DURATION_OUT}ms cubic-bezier(0.76, 0, 0.24, 1)`;

      requestAnimationFrame(() => {
        overlay.style.opacity = "1";

        overlay.addEventListener(
          "transitionend",
          () => {
            window.location.href = url.href;
          },
          { once: true },
        );
      });
    });
  });

  // Retour navigateur (bfcache) : la page est restaurée avec l'overlay encore
  // opaque. pageshow.persisted ne déclenche PAS DOMContentLoaded → on remet
  // l'overlay transparent et le body visible, sans transition.
  window.addEventListener("pageshow", (e) => {
    if (!e.persisted) return;
    overlay.style.transition = "none";
    overlay.style.opacity = "0";
    overlay.style.pointerEvents = "none";
    document.body.style.transition = "none";
    document.body.style.opacity = "1";
  });
};

const toCamelCase = (type) => {
  switch (type) {
    case "wipe-up":
      return "wipeUp";
    case "wipe-left":
      return "wipeLeft";
    case "fade":
    default:
      return "fade";
  }
};

export { initPageTransitions };
